<div class="container-fluid py-5">
  <object
    class="border"
    [data]="safeUrl"
    type="application/pdf"
    width="100%"
    height="700px"
  ></object>
</div>
